import { gql, useQuery } from '@apollo/client';
import useLoginState from '../../core/hooks/useLoginState';
import useStoreAndLanguageParams from '../../core/hooks/useStoreAndLanguageParams';
import type { ProductOrderRestriction } from '../types';

const productListOrderRestrictionQuery = gql`
    query productListOrderRestriction($store: ID!, $skuList: [String!]!) {
        productListOrderRestriction(store: $store, skuList: $skuList) {
            store
            sku
            restrictionId
        }
    }
`;

const useProductOrderRestrictions = ({
    skuList,
    skip,
}: {
    skuList?: string[];
    skip?: boolean;
}) => {
    const { store } = useStoreAndLanguageParams();

    const isLoggedIn = useLoginState();
    const { data, loading, error } = useQuery<{
        productListOrderRestriction: ProductOrderRestriction[];
    }>(productListOrderRestrictionQuery, {
        variables: {
            store,
            skuList,
        },
        skip: skip || !skuList || !isLoggedIn,
    });
    if (error) {
        throw error;
    }
    return {
        data,
        loading,
    };
};

export default useProductOrderRestrictions;
